import cx from 'classnames'

import Styles from './FontFamilyGroup.module.scss'

export const FontIcon = ({ className }: { className: string }) => {
  return <span className={cx(Styles.icon, className)}></span>
}
